import { gql } from '@apollo/client';

export const ALL_OUTCOME_THEMES = gql`
  query AllOutcomeThemes {
    getOutcomeThemes {
      id
      name
    }
  }
`;
